import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
import SelectFormQR from './../components/Complements/SelectFormQR';
import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getCodes } from "./../actions/codes";
import { urlVoucher } from '../services/urls';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab, FormControl, InputLabel, Select, MenuItem, Container, makeStyles, Typography, Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
import LoadingScreen from '../components/Complements/LoadingScreen';
import StandardDialog from '../components/Complements/StandardDialog';
import VoucherTransfersWeb from '../components/Transfers/VoucherTransfersWeb';
import { urlVoucherPersonas } from '../services/urls';
import { sendEmailWithVoucher } from "../actions/sendEmailWithVoucher";
import { findTransferCore2 } from "../actions/transferscore";
//import md5 from 'md5';
import { sendMobile } from '../functions/mobile';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import Footer from '../components/Complements/Footer';
import { filterArrayEqual } from '../functions/arrays';
import { IconButton } from '@mui/material';
import { ArrowBackIos, ConstructionOutlined } from '@mui/icons-material';
import { feathersCreateData, feathersFindData2 } from '../services';
import { exportExcel } from './../functions/exportExcel';

const useStyles = makeStyles((theme) => ({
  buttonViewMovements: {
    color: "#2E2757",
    [theme.breakpoints.up("xs")]: {
      fontSize: "70%",
      //fontFamily: 'HelveticaNeuelTstdMdcn',
    },
    [theme.breakpoints.up("sm")]: {
      fontSize: "80%",
      //fontFamily: 'HelveticaNeuelTstdMdcn',
    },
    [theme.breakpoints.up("md")]: {
      fontSize: "80%",
      //fontFamily: 'HelveticaNeuelTstdMdcn',
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "80%",
      //fontFamily: 'HelveticaNeuelTstdMdcn',
    },
    [theme.breakpoints.up("xl")]: {
      fontSize: "80%",
      //fontFamily: 'HelveticaNeuelTstdMdcn',
    },
  },
  divStandard: {
    //margin: "20px",
    padding: "20px",
    // border: '2px solid #BEBCC0',
    backgroundColor: theme.palette.type === "dark" ? "#4a4a4a" : "#fafafa",
    borderRadius: "16px",
    // boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'
  },
  letterscolors: {
    color: `${
      theme.palette.type === "dark" ? "#fafafa" : "#000000"
    } !important`,
  },
  rowStandard: {
    "& th": {
      color: theme.palette.type === "dark" ? "#ffffff" : "#000000",
    },
  },
}));

const VouchersQrPayment = props => {
    const { classes, balances, parameters, user,sendEmailWithVoucher,auth,handleOpenSnack } = props
    console.log(props)
    const monthLenght = filterArrayEqual(parameters,"code","PERIOD_MAXIMUMS_OF_MOVEMENT_OF_CONSULT")[0]

    const classes2 = useStyles()

    const [codespaginate, setCodesPaginate] = useState([])
    const [dataQR, setDataQR] = useState([])
    const [dataQRID, setDataQRID] = useState([])
    const [dataQRAll, setDataQRAll] = useState([])
    const [onlydata, setOnlyData] = useState([])
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    const [loading, setLoading] = useState(false)
    const [qrAppliedFilter, setQrAppliedFilter] = useState("todos_pagos");

      const [openWarningDialog, setOpenWarningDialog] = useState(false);
    const [dialog, setDialog] = useState({
        open: false,
        title: '',
        children: <div></div>
    })
    const [dateStart, setDateStart] = useState(new Date(moment().startOf('month')))
    //const [dateEnd, setDateEnd] = useState(new Date())
    const dateEnd = new Date()
    const [dateEndRange, setDateEndRange] = useState(dateEnd)
    const [dateValue, setDateValue] = useState(JSON.stringify({ month: moment().month(), year: moment().year() }))
    const [dataQRChoosed, setDataQRChoosed] = useState([])
    const [accountSelected, setAccountSelected] = useState(balances[0])


    const mount = () => {
        const unmount = () => {
            moment.locale('es-es')
            handleGetDataQRbyCompany()
            handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEndRange, 1, accountSelected.PRODUCTBANKID)
        }
        return unmount()
    }
    // const handleGetDataQRbyCompany = async () => {
    //         try {
    //             setLoading(true)
    //             const responseData = await feathersCreateData("report-qr", {})()
    //             console.log('la respuesta del responseData es',responseData)
    //             setDataQR(responseData.data)
    //             setDataQRAll(responseData.data)
    //             setLoading(false)
    //             //console.log('responseDaaaaata', responseData)

    //         } catch (error) {
    //           console.log('el error de aqui es',error)
    //             setLoading(false)
    //         }
    //  }
    const handleGetDataQRbyCompany = async () => {
  try {
    setLoading(true);
    const responseData = await feathersCreateData("report-qr", {})();

    //console.log('la respuesta del responseData es', responseData);

    const soloNombres = responseData.data.map(item => item.name);

    //console.log("solo los nombres:", soloNombres);

    setDataQR(soloNombres);
    setDataQRAll(responseData.data);

    setLoading(false);

  } catch (error) {
    //console.log('el error de aqui es', error);
    setLoading(false);
  }
};


const handleGetDataMovementsBySecuencialAccount = (
    rows,
    valuedateStart,
    valuedateEnd,
    numberpage,
    secuencial,
    idQR
) => {

    setLoading(true);

    const query = {
        $limit: 10,
        $skip: rows,
        state: true,
        createdAt: {
            $lte: valuedateEnd,
            $gte: valuedateStart
        },
        $sort: { createdAt: -1 }
    };

    if (idQR) query.idQR = idQR;

    findTransferCore2(query).payload
        .then(response => {
            const { data, total } = response;

            const resultWithQR = data.map(row => {

                // cubrir ambos casos: idQr e idQR
                const rowIdQR = row.idQr ?? row.idQR;

                const nombreQR = rowIdQR
                    ? (dataQRAll.find(qr => qr.id === rowIdQR)?.name || "QR inactivo")
                    : "Todos los QR";

                return {
                    ...row,
                    nombreQR
                };
            });

            setOnlyData(resultWithQR);
            convertJsonToData(resultWithQR, total, numberpage);
            setLoading(false);
        })
        .catch(error => {
            setLoading(false);
        });
};


    const convertJsonToData = (data, total, numberpage) => {
        let resul = [];
        //console.log('la data de esta seccion es',data)
data.forEach(row => {
    try {
        const tipo = (row.type === 9) ? 'TRANSFERENCIA A OTROS SOCIOS' :
                     (row.type === 18) ? 'TRANSFERENCIA INTERBANCARIA' :
                     (row.type === 41) ? 'PAGO QR' :
                     'TRANSFERENCIA A MIS CUENTAS';

        //  Aquí obtenemos el nombre del QR igual que en la tabla
        const nombreQR = row.idQr
            ? (dataQRAll.find(qr => qr.id === row.idQr)?.name || "QR inactivo")
            : "Todos los QR";

        resul.push({
            ...row,
            fechaTransaccion: row.createdAt,
            tipo,
            nombreQR   //  SE AGREGA AQUÍ
        });

    } catch (error) {
        // console.log(error);
    }
});


        //console.log("TODOS LOS MOVIMIENTOS: ", resul)

        setCodesPaginate(resul)

        getDataViewTable(total, numberpage);

    }

    useEffect(mount, [])

    const handleDateStart = (date) => {
        setDateStart(date)
    }

    const handleDateEnd = (date) => {
        setDateEndRange(date)
    }

    const onChangePaginationCodes = (e, numberpage) => {

        handleGetDataMovementsBySecuencialAccount((numberpage - 1) * 10, dateStart, dateEnd, numberpage, accountSelected.PRODUCTBANKID);
        //setTransactionPaginate(datacodespaginate)
        //setPage(numberpage)
    }

    const handleSubmit = (val) => {
        // console.log(val)
    }


    const getDataViewTable = (total, numberpage) => {
        // console.log("*** CODES ***", codes)
        let contador = parseInt((total / 10).toString());
        let residuo = total % 10;

        if (residuo > 0) {
            contador++;
        }

        setCount(contador)
        setPage(numberpage)
    }

    const handleAccountFind = (value) => {

        setAccountSelected(value)
        handleGetDataMovementsBySecuencialAccount(0, dateStart, dateEnd, 1, value.PRODUCTBANKID)

    }

    const handleDownloadPDF = async () => {
      // console.log('el onlydata para el excel es',onlydata)
    if (!onlydata || onlydata.length === 0) {
        // alert("No hay datos para descargar");
        setOpenWarningDialog(true);
        return;
    }
    const thedata = await feathersFindData2('generate-document-QR', 'user', { onlydata, dataQRChoosed })();
                //console.log('el valor de thedata es',thedata)
    window.open(urlVoucher + thedata.NombreArchivoVoucher+ ".pdf", '_blank');
};

const handleDownloadExcel = async () => {
    //console.log('los valores de los qr son', dataQRAll);
    //console.log('los valores de los onlydata son', onlydata);

    if (!onlydata || onlydata.length === 0) {
        setOpenWarningDialog(true);
        return;
    }

    const modifiedData = onlydata.map(item => {
        // Buscar el QR relacionado por id
        const qrFound = dataQRAll.find(qr => qr.id === item.idQr);

        return {
            ...item,
            originAccountNumber: item.originAccountNumber
                ? '# ' + item.originAccountNumber.replace('P1CU', '')
                : item.originAccountNumber,
            amount: item.amount !== undefined && item.amount !== null
                ? `$${Number(item.amount).toFixed(2)}`
                : item.amount,

            // Nuevo campo: nombre del QR
            qrName: qrFound ? qrFound.name : "Sin nombre"
        };
    });

    let headers = [
        'Fecha',
        '# Transaccion',
        'Concepto',
        'Monto',
        'CuentaOrigen',
        'TipoCuentaOrigen',
        'Nombre del QR'        //  Nuevo header
    ];

    let columnNames = [
        "createdAt",
        "transactionDocumentNumber",
        "concept",
        "amount",
        "originAccountNumber",
        "typeOriginAccount",
        "qrName"                //  Nuevo campo del modifiedData
    ];

    let docName = "PagosQR";
    let docType = 4;

    await exportExcel(headers, modifiedData, docName, columnNames, docType);
};





const handleSelectCode = (val) => {
    if (val === "todos_pagos") {
        const today = moment();
        const startCurrentMonth = today.clone().startOf("month");

        // Actualiza todos los estados
        setDateValue("todos_pagos");   // Esto actualiza el Select visual
        setDataQRChoosed("todos_pagos");
        setDataQRID(null);

        // Reinicia rango de fechas
        setDateStart(startCurrentMonth.toDate());
        setDateEndRange(today.toDate());

        // Trae todos los movimientos sin filtrar por QR
        handleGetDataMovementsBySecuencialAccount(
            0,
            startCurrentMonth.toDate(),
            today.toDate(),
            1,
            accountSelected.PRODUCTBANKID,
            null
        );

        return;
    }

    // Para un QR específico
    setDateValue(val);
    setDataQRChoosed(val);

    const selectedQR = dataQRAll.find(item => item.name === val);
    setDataQRID(selectedQR || null);
};





const handleFindRange = () => {

    // guardar el QR realmente aplicado (lo que se filtra)
    setQrAppliedFilter(dataQRChoosed);

    handleGetDataMovementsBySecuencialAccount(
        0,
        dateStart,
        dateEndRange,
        1,
        accountSelected.PRODUCTBANKID,
        dataQRID ? dataQRID.id : null
    );
};


    const handleConvertMask = (numberBeneficiary) => {

        if (numberBeneficiary.length > 7) {

            let resultConvert = ""

            const [a, b, c, d, ...dataConvert] = numberBeneficiary

            const inicioFin = dataConvert.length - 3

            const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

            for (let y = 0; y < inicioFin; y++) {
                resultConvert = resultConvert.concat("X")
            }

            resultConvert = a + b + c + d + resultConvert + ultimos

            return resultConvert

        } else {

            return numberBeneficiary

        }

    }

    const handleViewVoucher = (row) => {
        // console.log("MOVIMIENTO SELECCIONADO: ", row)
        //let documento = (row.Documento) ? row.Documento : row.documento;
        const { nombreArchivoComprobante } = row;

        const handleSendEmailWithVoucher = () => {
            setLoading(true)

            const { email } = auth;


            // console.log("Documento: ", nombreArchivoComprobante);

            //const { Monto, NumeroCuentaOrigen } = responseservertransfer;

            let object_send_email_with_voucher = {
                Documento: nombreArchivoComprobante,
                Email: email
            }

            sendEmailWithVoucher(object_send_email_with_voucher).then(
                response => {

                    const { message, type } = response.payload;


                    handleOpenSnack(message, type);
                    setLoading(false)
                }
                ).catch(
                    error => {
                    setLoading(false)
                    handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
                    }
                )
        }

        setDialog({
            open: true, title: 'Comprobante',
            children: <Container component="main" maxWidth="xl">
                <VoucherTransfersWeb
                    title={"TRANSFERENCIA EXITOSA"}
                    titleone={"DATOS EMISOR"}
                    viewVoucher={true}
                    databodyone={[
                        {
                            title: "Nombres",
                            value: user.Name,
                            order: 1
                        },
                        {
                            title: "Cuenta",
                            value: handleConvertMask(row.numeroCuentaOrigen),
                            order: 2
                        },
                        {
                            title: "Fecha",
                            value: moment(row.fecha).format("YYYY-MM-DD"),
                            order: 3
                        },
                        {
                            title: "Concepto",
                            value: row.concepto,
                            order: 4
                        },
                        {
                            title: "Dcto. de trans",
                            value: row.numeroMensajeTransaccion,
                            order: 5
                        },
                        {
                            title: "Comisión",
                            value: "$ " + row.comision,
                            order: 5
                        }
                    ]}
                    titletwo={"DATOS BENEFICIARIO"}
                    databodytwo={[
                        {
                            title: "Nombres",
                            value: row.nombreBeneficiario,
                            order: 1
                        },
                        {
                            title: "Cuenta",
                            value: handleConvertMask(row.numeroCuentaDestino),
                            order: 2
                        },
                        {
                            title: "Institución",
                            value: row.institucion,
                            order: 3
                        },
                    ]}
                    nombreCliente={row.nombreCliente}
                    numeroCuentaOrigen={''}
                    tipoCuentaOrigen={row.tipoCuentaOrigen}
                    nombreBeneficiario={row.nombreBeneficiario}
                    numeroCuentaDestino={''}
                    tipoCuentaDestino={row.tipoCuentaDestino}
                    institucion={row.institucion}
                    monto={row.monto}
                    comision={row.comision}
                    concepto={row.concepto}
                    fecha={row.fecha}
                    dispositivo={row.dispositivo}
                    typesizegrid={6}
                    handleDownloadVoucher={() => {
                        let namefile = row.nombreArchivoComprobante
                        window.open(urlVoucherPersonas + namefile + ".pdf", '_blank');
                    }}
                    handleDownloadDevice={() => {
                        try {
                            let namefile = row.nombreArchivoComprobante
                            let send = {
                                type: 'action',
                                action: 'export_voucher',
                                data: urlVoucherPersonas + namefile + ".pdf",
                                nameFile: namefile,
                                extension: 'pdf',
                                messageSend: 'Transferencia'
                            }
                            sendMobile(JSON.stringify(send))
                        } catch (error) {
                            //console.log(error)
                        }
                    }}
                    handleSendEmailWithVoucher={handleSendEmailWithVoucher}
                />
            </Container>
        })

    }
    const handleCLoseDialog = () => {
        setDialog({ ...dialog, open: false })
    }
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
          //console.log('el codespaginate es',codespaginate)
            if (codespaginate.length > 0) {
                return <div className={"container"}>
                    <Grid item xs={12} md={12} lg={12}>
                        <Table className={"table"}>
                            <Thead>
                                <Tr className={classes2.rowStandard}>
                                    <Th>Fecha</Th>
                                    <Th>QR</Th>
                                    <Th>Tipo</Th>
                                    <Th>Concepto</Th>
                                    <Th>Cuenta Origen</Th>
                                    <Th className={"colunmvalue"}>Monto</Th>
                                    <Th>Comprobante</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {
                                    codespaginate.map(row => (
                                        <Tr key={`${row.transactionDocumentNumber}`}>
                                            <Td>{moment(row.createdAt).format("YYYY-MM-DD HH:mm:ss")}</Td>
<Td>
  {row.idQr
    ? (dataQRAll.find(qr => qr.id === row.idQr)?.name || "QR inactivo")
    : "Todos los QR"}
</Td>





                                            <Td>{'PAGOS CON QR'}</Td>
                                            <Td>{row.concept}</Td>
                                            <Td> # {(row.originAccountNumber.replace('P1CU', ''))}</Td>
                                            <Td>$ {row.amount}</Td>
                                            <Td>
<Button
    variant='contained'
    aria-label="delete"
    onClick={() => {
        let namefile = row.fileName;
        window.open(urlVoucherPersonas + namefile + ".pdf", "_blank");
    }}
>
    <Typography className={classes2.buttonViewMovements} align="left">
        VER
    </Typography>
</Button>

                                                {/* <IconButton edge="end" aria-label="delete" onClick={() => handleViewVoucher(row)}>
                                                    <Typography className={classes2.buttonViewMovements} align="left">
                                                        VER
                                                    </Typography>
                                                </IconButton> */}
                                            </Td>
                                        </Tr>
                                    ))

                                }

                            </Tbody>
                        </Table>
                        <Pagination
                            style={{ marginTop: '5px' }}
                            count={count}
                            page={page}
                            onChange={onChangePaginationCodes}
                        />
                    </Grid>
                </div>
            } else {
                return <Alert severity="info">No se han encontrado movimientos en el mes seleccionado.</Alert>
            }
        }
    }
const parameters1 = [
  { value: "todos_pagos", label: "Todos los QR" },
  ...dataQR.map((item) => ({
    value: item,
    label: item
  }))
];


    const renderBody = () => {
        return <div className={classes2.divStandard}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={12} lg={12} sm={12}>
                    <Title className={classes2.letterscolors}>Detalle de movimientos de la Cuenta </Title>
                </Grid>
                {/* <Grid item xs={12} md={4} lg={4} sm={12}>

                </Grid> */}
            </Grid>
            <SelectFormQR
  name="Periodo"
  label="Seleccione el QR"
  parameters={parameters1}
  classes={classes}
  dateValue={dateValue}
  onSelected={handleSelectCode}
  onSubmit={handleSubmit}
            ></SelectFormQR>
            <br></br>
<Grid container spacing={2}>
  <Grid item xs={12}>
    <Grid
      container
      spacing={2}
      alignItems="center"
      justifyContent="center"
      wrap="nowrap"   // evita que nada se vaya a otra linea
    >

      {/* FECHA INICIO */}
      <Grid item style={{ flexGrow: 1, minWidth: 220 }}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
          <KeyboardDatePicker
            autoOk
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            label="Fecha de inicio"
            value={dateStart}
            onChange={handleDateStart}
            keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
          />
        </MuiPickersUtilsProvider>
      </Grid>

      {/* FECHA FIN */}
      <Grid item style={{ flexGrow: 1, minWidth: 220 }}>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
          <KeyboardDatePicker
            autoOk
            variant="inline"
            format="dd/MM/yyyy"
            margin="normal"
            label="Fecha de fin"
            value={dateEndRange}
            onChange={handleDateEnd}
            keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
          />
        </MuiPickersUtilsProvider>
      </Grid>

      {/* BOTÓNES */}
      <Grid item xs="auto" container direction="column" alignItems="center">
        <Fab size="small" style={{ backgroundColor: '#2E2757' }} onClick={handleFindRange}>
          <Icon style={{ color: "#FFFFFF" }}>search</Icon>
        </Fab>
        <Typography variant="subtitle2">CONSULTAR</Typography>
      </Grid>

      {/* CANCELAR */}
      <Grid item xs="auto" container direction="column" alignItems="center">
        <Fab size="small" style={{ backgroundColor: '#2E2757' }} onClick={() => handleSelectCode("todos_pagos")}>
          <Icon style={{ color: "#FFFFFF" }}>close</Icon>
        </Fab>
        <Typography variant="subtitle2">CANCELAR</Typography>
      </Grid>


      <Grid item xs="auto" container direction="column" alignItems="center">
        <Fab size="small" style={{ backgroundColor: '#2E2757' }} onClick={handleDownloadPDF}>
          <Icon style={{ color: "#FFFFFF" }}>picture_as_pdf</Icon>
        </Fab>
        <Typography variant="subtitle2">PDF</Typography>
      </Grid>

      <Grid item xs="auto" container direction="column" alignItems="center">
        <Fab size="small" style={{ backgroundColor: '#2E2757' }} onClick={handleDownloadExcel}>
          <Icon style={{ color: "#FFFFFF" }}>grid_on</Icon>
        </Fab>
        <Typography variant="subtitle2">EXCEL</Typography>
      </Grid>

    </Grid>
  </Grid>
</Grid>

            <br /> <br />
            <Grid container spacing={3} justifyContent="center" alignItems="center" m={30}>
                {
                    renderTableMovements()
                }
            </Grid>
        </div>
    }

    const handleMaskNumberAccount = (numberBeneficiary) => {

        if (numberBeneficiary.length > 7) {

            let resultConvert = ""

            const [a, b, c, d, ...dataConvert] = numberBeneficiary

            const inicioFin = dataConvert.length - 3

            const ultimos = dataConvert.join('').slice(inicioFin, dataConvert.length)

            for (let y = 0; y < inicioFin; y++) {
                resultConvert = resultConvert.concat("X")
            }

            resultConvert = a + b + c + d + resultConvert + ultimos

            return resultConvert

        } else {

            return numberBeneficiary

        }
    }

    const renderHeader = () => {
        return <div className={classes2.divStandard}>
          <Title className={classes2.letterscolors}>Pagos QR Realizados</Title>
            {/* <Grid container>
                <Title>Pagos QR Realizados</Title>
                <FormControl variant="outlined" style={{ minWidth: '100%' }}>
                    <InputLabel id="demo-simple-select-outlined-label">Seleccione una Cuenta</InputLabel>
                    <Select
                        label="Seleccione una Cuenta"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue={balances[0]}
                        onChange={(e) => handleAccountFind(e.target.value)}
                    >
                        {
                            balances.map(option => {
                                return <MenuItem key={option.PRODUCTBANKID} value={option}>{`${handleMaskNumberAccount(option.PRODUCTBANKID)} - ${option.PRODUCTALIAS}`}</MenuItem>
                            })
                        }
                    </Select>
                </FormControl>
            </Grid> */}
        </div>
    }
    return (
        <div>
            <Grid xs={12} style={{padding:"20px 40px 0"}} >
                <Title><IconButton onClick={() => history.push("/")} style={{ marginRight: "8px" }}><ArrowBackIos /></IconButton>Comprobantes</Title>
            </Grid>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                info={renderHeader()}
                multiple={true}
                panel={2}
            />
            <Footer />
            <LoadingScreen open={loading} />
            <StandardDialog
                handleClose={handleCLoseDialog}
                open={dialog.open}
                title={dialog.title}>
                {dialog.children}
            </StandardDialog>
                  <Dialog open={openWarningDialog} onClose={() => setOpenWarningDialog(false)}>
                    <DialogTitle style={{ textAlign: 'center' }}>Mensaje</DialogTitle>
                    <DialogContent>
                      <Typography>No hay pagos realizados al QR filtrado.</Typography>
                    </DialogContent>
                    <DialogActions style={{ justifyContent: 'center', marginTop: '16px' }}>
                          <Button
                            onClick={() => setOpenWarningDialog(false)}
                            style={{ backgroundColor: '#c29914', color: 'white' }}
                          >
                            Cerrar
                          </Button>
                    </DialogActions>
                  </Dialog>
        </div>
    );
};

VouchersQrPayment.propTypes = {
    balances: PropTypes.array.isRequired,
};

export default connect(null, { getCodes, sendEmailWithVoucher, findTransferCore2 })(VouchersQrPayment);
